/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import { withTranslation } from "react-i18next";
import { DialogContent, DialogContentText } from "@mui/material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import { Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CancelDialog = (props) => {
  return (
    <Dialog
      disableScrollLock={true}
      open={props.isOpen}
      PaperComponent={DraggableDialogPaper}
      maxWidth={"xs"}
      fullWidth={true}
    >
      <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
        <div style={{ display: "flex" }}>
          <span style={{ display: "inline-flex", width: "95%" }}>
            {props.t("CANCEL_ADDON")}
          </span>
          <Tooltip title={props.t("CLOSE")}>
            <IconButton
              onTouchStart={() => props.close(false)}
              onClick={() => props.close(false)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          {props.t("DO_YOU_WANT_TO_CONTINUE")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.close(false);
          }}
        >
          {props.t("NO")}
        </Button>
        <Button
          onClick={() => {
            props.close(true);
          }}
        >
          {props.t("YES")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

export default withTranslation("translations")(CancelDialog);
